import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Instance axios partagée : envoie systématiquement le cookie httpOnly d'auth.
export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Convertit un `detail` d'erreur FastAPI (string, array ou objet) en texte affichable.
export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
